import { render, staticRenderFns } from "./resumoDeRodadas.vue?vue&type=template&id=39d75753&"
import script from "./resumoDeRodadas.vue?vue&type=script&lang=js&"
export * from "./resumoDeRodadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports